import { Link } from '#components/atoms/link/Link.tsx';
import { FAQRow } from '#screens/settings/billing/upsell-faq/FAQRow.tsx';
import styles from './UpsellFAQ.module.css';

export function UpsellFAQ() {
  return (
    <section className={styles.UpsellFAQ}>
      <h2 className="h4">FAQs</h2>
      <FAQRow summary="What is considered a billable host?">
        Hosts, lighthouses, and relays are all considered to be “hosts” for billing purposes. All enrolled hosts are
        considered billable until they are blocked or deleted, at which point they will no longer accumulate usage.
      </FAQRow>
      <FAQRow summary="How is usage calculated?">
        If a host is enrolled for an entire month it will cost $1. If a host is not enrolled for an entire month, it
        will be prorated for the portion of the month it was enrolled. After summing the usage of all hosts, fractional
        usage will be dropped and only whole dollar values will be billed.
      </FAQRow>
      <FAQRow summary="What is priority support?">
        Our team gives top priority to all Pro and Enterprise customer support requests. These support requests will be
        placed at the top of our queue.
      </FAQRow>
      <FAQRow summary="How do I update my payment information?">
        While logged into your account, navigate to Settings → Billing. Within this page, you can access your billing
        details and manage your payment information via Stripe by clicking on “Manage Account” under the “Billing
        Managed by Stripe” section.
      </FAQRow>
      <FAQRow summary="Is my information secure?">
        Yes, all billing information is securely maintained by a trusted partner, Stripe. You can read more about their{' '}
        <Link className="a" to="https://stripe.com/docs/security">
          security protocols
        </Link>
        .
      </FAQRow>
      <FAQRow summary="What is your cancellation policy?">
        Should you opt to downgrade or delete your account, charges will be incurred for your usage up until that point.
        All accounts can be downgraded to the Free plan, but some account features may be restricted if there are over
        100 hosts after downgrading.
      </FAQRow>
      <FAQRow summary="How do I delete my account?">
        Contact{' '}
        <Link className="a" to="/support/contact">
          Support
        </Link>{' '}
        if you’d like to have your account deleted.
      </FAQRow>
      <FAQRow summary="What payment methods do you accept?">
        We accept Visa, Mastercard, American Express, Discover, JCB, Diners Club, and China UnionPay. If you’re
        interested in additional payment options contact{' '}
        <Link className="a" to="/support/contact">
          Support
        </Link>
        .
      </FAQRow>
      <FAQRow summary="When will I be charged?">
        To keep things simple, we use calendar months as our billing periods. Your first bill will be prorated, and your
        account will be charged following the conclusion of each month.
      </FAQRow>
    </section>
  );
}
